var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditMemoIcon = function SvgCreditMemoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    fillRule: "evenodd",
    d: "M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zm8.8 10.148c1.68 0 2.7-.87 3.335-1.866l-1.244-.635A2.44 2.44 0 0 1 8.8 10.848c-1.643 0-2.862-1.257-2.862-3 0-1.741 1.22-2.998 2.862-2.998.896 0 1.692.522 2.09 1.207l1.245-.635c-.622-.995-1.655-1.866-3.335-1.866-2.452 0-4.356 1.742-4.356 4.293s1.904 4.293 4.356 4.293"
  })));
};
export default SvgCreditMemoIcon;